import React, { useState, useEffect, useContext } from "react";
import * as THREE from "three";
import { useLocation } from "react-router-dom";
import gsap from "gsap";
import { AudioContext } from "../components/utils/AudioContext";
import videoSrc from "/videos/ina.mp4";

const videoElement = (() => {
    const video = document.createElement("video");
    video.src = videoSrc;
    video.crossOrigin = "Anonymous";
    video.loop = true;
    video.muted = true;
    video.playsInline = true;
    video.play();
    return video;
})();

export default function Tele() {
  return (
    <mesh position={[-8.28, 2.78, 29.7]} scale={[0.18, 0.22, 0.2]} rotation={[0, THREE.MathUtils.degToRad(28), 0]}>
      <planeGeometry args={[3.2, 1.9]} />
      <meshStandardMaterial emissive={"white"} side={THREE.DoubleSide}>
        <videoTexture attach="map" args={[videoElement]} />
        <videoTexture attach="emissiveMap" args={[videoElement]} />
      </meshStandardMaterial>
    </mesh>
  );
}